import { render } from "./DelegationBanner.vue?vue&type=template&id=2f9e0d65&scoped=true"
import script from "./DelegationBanner.vue?vue&type=script&lang=js"
export * from "./DelegationBanner.vue?vue&type=script&lang=js"

import "./DelegationBanner.vue?vue&type=style&index=0&id=2f9e0d65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9e0d65"]])

export default __exports__